import { ISearchIndexabilityManager, SearchIndexabilityManager } from "@studyportals/fawkes/programmes-search-seo";
import { SeoInfoBase } from "./SeoInfoBase";
import { SeoFilterState } from "./SeoFilterState";
import { SeoApplicationState } from "./SeoApplicationState";

export class Indexability {
	private indexabilityManager: ISearchIndexabilityManager;
	private static instance: Indexability;

	private constructor() {
		this.indexabilityManager = new SearchIndexabilityManager(
			window.PortalType,
			new SeoInfoBase(),
			new SeoFilterState(),
			SeoApplicationState.getInstance()
		);
	}

	public static getInstance(): Indexability {
		if (!Indexability.instance) {
			Indexability.instance = new Indexability();
		}
		return Indexability.instance;
	}

	public async shouldIndex(): Promise<boolean> {
		return this.indexabilityManager.shouldIndex();
	}
}